module.exports = __webpack_public_path__ + "img/skate-quiz-single-male.9b244636.png";